<template lang="pug">
    .citas
        h3 Tus citas
        .wrapper-listado
          .border-wrap
            .listado-header
              .accion-listado
                .action
          .wrapper-body
              table.table.table-striped
                thead
                  th
                    | Nombre del paciente
                  th
                    | Fecha
                tbody
                    tr(v-for='(cita, $index) in citas' v-bind:key='$index')
                        td
                            |{{cita.name}}
                        td
                            | {{cita.date}}
                        td.tools
        </template>

<script>
import gun from "../managers/gun";
export default {
  data() {
    return {
      citas: []
    };
  },
  async created() {
    console.log("wololo");
    gun
      .get("citas_medicas")
      .map()
      .on(data => {
        console.log(data)
        if (data.medic == gun.user().is.pub) {
            let cita = {}
                this.citas.push(cita)
            gun.user(data.patient).get('profile').on((profile) => {

                var date = new Date(data.date)
               cita.name = profile.name
               cita.date = date.toLocaleDateString("es-ES", { weekday: "long", year: "numeric", month: "long", day: "numeric"})
 
            })
            
           
            // this.citas.push(cita)
        }
      });
  }
};
</script>